import React, { useEffect } from "react";
import { Card, Button, Descriptions, Tag, Alert, Typography } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";

const { Text } = Typography;

/**
 * Payment Failed Page
 * Shown after failed payment or payment cancellation
 */
const PaymentFailed = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);
  const paymentId = params.get("paymentId");
  const error = params.get("error");

  useEffect(() => {
    // Optional: Send analytics event
    console.log("Payment Failed:", { paymentId, error });
  }, [paymentId, error]);

  const failureTime = new Date().toLocaleString();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
        padding: "20px 16px",
      }}
    >
      <Card
        style={{ maxWidth: 550, width: "100%" }}
        bodyStyle={{ padding: "32px 24px" }}
      >
        <div style={{ textAlign: "center" }}>
          <CloseCircleOutlined style={{ fontSize: 56, color: "#ff4d4f" }} />
          <h2
            style={{
              fontSize: 24,
              fontWeight: 600,
              margin: "16px 0 8px",
              color: "#262626",
            }}
          >
            Payment Failed
          </h2>
          <p style={{ fontSize: 14, color: "#595959", margin: 0 }}>
            Your payment could not be completed. Please try again.
          </p>
        </div>

        {error && (
          <Alert
            message="Failure Reason"
            description={error}
            type="error"
            showIcon
            style={{ margin: "24px 0 16px", fontSize: 13 }}
          />
        )}

        <div style={{ margin: "24px 0" }}>
          <Descriptions
            column={1}
            size="small"
            bordered
            style={{ fontSize: 13 }}
          >
            {paymentId && (
              <Descriptions.Item
                label="Transaction ID"
                labelStyle={{ width: 140, fontSize: 12 }}
                contentStyle={{ fontSize: 12 }}
              >
                <Text code style={{ fontSize: 11 }}>
                  {paymentId}
                </Text>
              </Descriptions.Item>
            )}
            <Descriptions.Item
              label="Status"
              labelStyle={{ fontSize: 12 }}
              contentStyle={{ fontSize: 12 }}
            >
              <Tag color="error" style={{ fontSize: 11 }}>
                FAILED
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item
              label="Failed At"
              labelStyle={{ fontSize: 12 }}
              contentStyle={{ fontSize: 12 }}
            >
              <Text>{failureTime}</Text>
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div style={{ marginTop: 24 }}>
          <Alert
            message="Common Issues & Solutions"
            description={
              <div style={{ fontSize: 12 }}>
                <div>• Check if your card has sufficient balance</div>
                <div>• Verify card details (number, CVV, expiry)</div>
                <div>• Enable online/international transactions</div>
                <div>• Try a different payment method</div>
                <div>• Contact your bank if payment was deducted</div>
              </div>
            }
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />

          <Button
            type="primary"
            size="large"
            block
            onClick={() => {
              const erpUrl =
                process.env.REACT_APP_ERP_URL || "http://localhost:3000";
              const redirectUrl = `${erpUrl}/default/adminmodule/whatsapp-credits`;

              if (paymentId) {
                // If we have payment ID, retry payment
                navigate(`/payment?paymentId=${paymentId}`);
              } else if (window.opener) {
                // If opened in popup, post message and redirect parent
                window.opener.postMessage(
                  {
                    type: "PAYMENT_FAILED",
                    paymentId: paymentId,
                    error: error,
                  },
                  "*",
                );
                window.opener.location.href = redirectUrl;
                window.close();
              } else {
                // Direct redirect to ERP WhatsApp Credits page
                window.location.href = redirectUrl;
              }
            }}
            style={{ height: 44, fontSize: 15, fontWeight: 500 }}
          >
            {paymentId ? "Retry Payment" : "Return to Application"}
          </Button>

          <div style={{ textAlign: "center", marginTop: 16 }}>
            <Text type="secondary" style={{ fontSize: 12, display: "block" }}>
              Need assistance? Contact us:
            </Text>
            <Text strong style={{ fontSize: 13, color: "#1890ff" }}>
              support@bharatonline.com
            </Text>
            <div style={{ marginTop: 4 }}>
              <Text type="secondary" style={{ fontSize: 11 }}>
                Reference this Transaction ID when contacting support
              </Text>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PaymentFailed;
